export default [
    {
      displayName: '系统首页',
      name: 'public',
      path: '/public',
      src: require('../assets/img/home.png'),
      activeSrc: require('../assets/img/activeHome.png')
    },
    {
      displayName: '政策法规',
      name: 'news',
      path: '/news',
      src: require('../assets/img/regulations.png'),
      activeSrc: require('../assets/img/avtiveRegulations.png')
    },
    {
      displayName: '征收计划',
      name: 'incident',
      path: '/incident',
      src: require('../assets/img/levyPlan.png'),
      activeSrc: require('../assets/img/activeLevyPlan.png')
    },
    {
      displayName: '通知公告',
      name: 'theme',
      path: '/theme',
      src: require('../assets/img/announcement.png'),
      activeSrc: require('../assets/img/activeAnnouncement.png')
    },
    {
      displayName: '办事指南',
      name: 'articles',
      path: '/articles',
      src: require('../assets/img/handlingGuideline.png'),
      activeSrc: require('../assets/img/activeHandlingGuideline.png')
    }
  ];
  


// WEBPACK FOOTER //
// ./src/layout/menus.js